import Header from "@/pages/home/components/Header";
import Footer from "@/pages/home/components/Footer";
import StickyCta from "@/pages/home/components/StickyCta";
import Contact from "@/pages/home/components/Contact";
import ServiceHero from "@/pages/fuyouhin-kaisyu/components/ServiceHero";
import Reasons from "@/pages/fuyouhin-kaisyu/components/Reasons";
import Items from "@/pages/fuyouhin-kaisyu/components/Items";
import Comparison from "@/pages/fuyouhin-kaisyu/components/Comparison";
import Pricing from "@/pages/fuyouhin-kaisyu/components/Pricing";
import Flow from "@/pages/fuyouhin-kaisyu/components/Flow";
import Cases from "@/pages/fuyouhin-kaisyu/components/Cases";
import Areas from "@/pages/fuyouhin-kaisyu/components/Areas";
import Faq from "@/pages/fuyouhin-kaisyu/components/Faq";
import Trust from "@/pages/fuyouhin-kaisyu/components/Trust";

const fuyouhinNavItems = [
  { href: "#reasons", label: "選ばれる理由" },
  { href: "#items", label: "回収品目" },
  { href: "#comparison", label: "自治体比較" },
  { href: "#pricing", label: "料金目安" },
  { href: "#flow", label: "作業の流れ" },
  { href: "#cases", label: "作業事例" },
  { href: "#areas", label: "対応エリア" },
  { href: "#faq", label: "よくある質問" },
  { href: "#trust", label: "運営会社" },
];

export default function FuyouhinKaisyuPage() {
  return (
    <div className="w-full min-w-[320px] bg-background-50 text-foreground-950">
      <Header linkPrefix="" navItems={fuyouhinNavItems} />
      <main>
        <ServiceHero />
        <Reasons />
        <Items />
        <Comparison />
        <Pricing />
        <Flow />
        <Cases />
        <Areas />
        <Faq />
        <Trust />
        <Contact />
      </main>
      <Footer linkPrefix="/" />
      <StickyCta />
    </div>
  );
}